<template>
<v-container fill-height>
		<v-row justify="center" align="center">
			<v-col cols="12">
	<v-card class="mx-auto" max-width="400" :loading="loading">
		<v-img src="@/assets/escudo.png" height="200" width="200" class="mx-auto align-center mt-4"></v-img>
		<v-card-title class="justify-center">Cadastrar Nova novaSenha</v-card-title>
		<v-card-text>
			<v-text-field dense label="Nova Senha" class="emailInput" v-model="user.novaSenha" type="password" outlined></v-text-field>
			<v-text-field dense label="Confimar Senha" class="senhaInput" v-model="user.novaSenhaConfirmada" @keydown.enter="login" type="password" outlined></v-text-field>
		</v-card-text>
		<v-card-actions>
			<v-btn class="mx-auto" color="primary" @click="cadastrar" small>Cadastrar</v-btn>
		</v-card-actions>
	</v-card>
			</v-col>
		</v-row>
</v-container>
</template>

<script scoped>
import { baseApiUrl, showError, showSuccess } from '@/config/global'
import axios from 'axios'
import { mapState } from 'vuex'
	
	export default{
		name: 'NovaSenha',
		components:{},
		computed:{
			... mapState(['buscandoDados'])
		},
		data(){
			return{
				user: {},
			}
		},

		methods: {
			cadastrar(){
				
				if(this.user.novaSenha && this.user.novaSenha === this.user.novaSenhaConfirmada){
					
					this.$store.commit('alteraBuscandoDados', true)
					const url = `${baseApiUrl}/usuarios/atualizarSenha.php` 	
					
					axios.post(url, this.user)
					.then(res => {
						
						if(res.data.codigo == '01'){

							showSuccess(res.data.mensagem)
							this.$store.commit('alteraBuscandoDados', false)
							this.$router.push({path: 'auth'})
							
						}else{
							
							showError(res.data.mensagem)
							this.$store.commit('alteraBuscandoDados', false)
						}
					})
					.catch({showError})


				}else{
					showError('Senhas não conferem!')
				}

				
				
				
				
			},

			confirmaToken(token){
				const url = `${baseApiUrl}/utils/validaToken.php`
				axios.post(url, {token: token})
				.then(res => {
					
					if(res.data.codigo == '01'){
						this.user.email = res.data.email
					}else{
						showError(res.data.mensagem)
						this.$router.push({path: 'auth'})
						return
					}
				})
			}
			
		},
	
		created(){
			this.confirmaToken(this.$route.params.token)
		}
	}


</script>

<style scoped>
	.auth-content{
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.auth-content img{
		position: static;
		left: 0;
		top: 0;
	}

	.auth-modal{
		background-color: #fff;
		width: 350px;
		padding: 35px;
		box-shadow: 0 1px  5pxrgba(0,0,0,0.15);

		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.auth-title {
		font-size: 1.2rem;
		font-weight: 100;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.auth-modal .emailInput, .auth-modal .senhaInput {
		border: 1px solid #bbb;
		width: 100%;
		padding: 3px 8px;
		outline: none;
		color: rgba(70,70,70,1);
	}

	.auth-modal .emailInput{
		margin-bottom: 15px;
	}

	.auth-modal .btn-cadastrar {
		align-self: center;
		background-color: rgba(60, 15, 138, 1) !important;
		color: #fff;
		padding: 5px 15px;
	}

	.auth-modal a{
		margin-top: 35px;
	}

	.auth-modal hr{
		border: 0;
		width: 100%;
		height: 3px;
		background-image: linear-gradient(to right, rgba(120, 120, 120, 0), rgba(120, 120, 120, 0.75), rgba(120,120,120,0));
	}

	.recuperarSenha{
		font-size: 0.7rem;
		align-self: flex-end;
		cursor: pointer;
		margin-bottom: 10px;
	}
</style>